<script lang="ts">
  import {getContext, onMount, onDestroy} from 'svelte';
  import {cn} from 'Catalyst/cn';
  import {carouselCardTvProps} from '.';
  import type {CarouselContext} from '../Carousel';

  const carouselContext = getContext<CarouselContext>('carouselContext');
  let cardId: number = -1;
  let selected: boolean = false;
  let cardRef: HTMLDivElement | null = null;

  $: carouselStore = carouselContext?.store;

  $: currentIndex =
    carouselStore && cardId >= 0
      ? $carouselStore.cardRegistry.get(cardId) ?? -1
      : -1;

  $: cardTvSlots = carouselCardTvProps({selected});

  $: if (carouselStore && currentIndex >= 0) {
    selected = $carouselStore.selectedIndex === currentIndex;
  }

  onMount(() => {
    if (carouselContext?.registerCard) {
      const registration = carouselContext.registerCard();
      cardId = registration.cardId;
    } else {
      throw new Error(
        'CarouselCard must be rendered within a Carousel component'
      );
    }
  });

  onDestroy(() => {
    if (carouselContext?.unregisterCard && cardId >= 0) {
      carouselContext.unregisterCard(cardId);
    }
  });

  $: tabIndex = selected ? 0 : -1;

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'ArrowRight') {
      carouselContext.scrollNext();
      const nextCard = cardRef?.nextElementSibling as HTMLElement;
      if (nextCard && nextCard.getAttribute('role') === 'radio') {
        nextCard.focus({preventScroll: true});
      }
    } else if (event.key === 'ArrowLeft') {
      carouselContext.scrollPrev();
      const prevCard = cardRef?.previousElementSibling as HTMLElement;
      if (prevCard && prevCard.getAttribute('role') === 'radio') {
        prevCard.focus({preventScroll: true});
      }
    }
  };
</script>

<div
  class={cn(cardTvSlots.base())}
  tabindex={tabIndex}
  role="radio"
  aria-checked={selected}
  on:keydown={handleKeyDown}
  bind:this={cardRef}
  {...$$restProps}
>
  <slot />
</div>
